import _ from 'lodash'
import { ENV_TYPE, SUB_FLOW } from '../../../../lib/constants'

// retries for loading pa.js
let retries = 0

export const PAYPAL = window.PAYPAL || {}

export function getSubFlow(env, isMoneyMovementTrmt) {
  if (isMoneyMovementTrmt) {
    return SUB_FLOW.MONEY_MOVEMENT
  }

  const ENV_TO_SUB_FLOW_MAP = {
    [ENV_TYPE.SUMMARY]: 'send_again',
    [ENV_TYPE.GROUPS]: SUB_FLOW.GROUPS,
  }

  const subFlow = ENV_TO_SUB_FLOW_MAP[env]
  return subFlow || SUB_FLOW.SEND_MONEY
}

export function getBooleanString(value) {
  if (value) {
    return 'y'
  }
  return 'n'
}

// instantiate the view (with a backup for mocks mode)
const emptyAnalytics = {
  logActivity() {},
  recordClick() {},
  recordImpression() {},
  record() {},
  recordError() {},
}
export let analytics = emptyAnalytics

let isInitialized = false
analyticsReady(() => {
  analytics =
    PAYPAL.analytics &&
    PAYPAL.analytics.Analytics &&
    new PAYPAL.analytics.Analytics()
  isInitialized = true
})

/**
 * PA.js has a 500ms delay between its inception and setup initialization, and we need to know when
 * the setup is really complete before firing our analytic calls. PA.js allows us to overwrite their
 * noop setupComplete function with our own function, which we do in pageTracking.dust -
 * Our logic simply specifies that when setupComplete is invoked, set _.isReady to true.
 */
export function analyticsReady(callback, requiresInitialization = false) {
  const analyticsIsReady = _.get(PAYPAL, 'analytics._isReady')
  if (requiresInitialization) {
    if (isInitialized) {
      return callback()
    }
  } else if (analyticsIsReady) {
    return callback()
  }
  // wait up to 150s for analytics to initialize
  // we give up analytics eventually
  retries++
  if (retries > 1000) {
    return
  }
  return setTimeout(() => analyticsReady(callback, requiresInitialization), 150)
}

/**
 * Wrap any anonymous function in the analyticsReady function
 */
export function whenReady(fn) {
  return (...args) => analyticsReady(() => fn(...args), true)
}
